module.exports = __webpack_public_path__ + "media/top/freelance_no_1-c9d3a70e.svg";